@let filterConfig = filterConfigSignal();
<ic-page-filter-control
	class="home-control"
	inputId="home"
	[isReadonly]="isHomeReadonly()"
	[placeholder]="'pageFilter.home.search' | translate"
	[selectedOption]="selectedHomeOption()"
	[selectedOptionLabel]="selectedHomeOptionLabelFn"
	[showLoadingSpinner]="!homeOptions().length"
	[suggestions]="homeSuggestions()"
	[(query)]="homesQuery"
	(selectedId)="onHomeSelected($event)"
>
	<ng-template #optionTemplate let-item>
		{{ item.name }}
	</ng-template>
</ic-page-filter-control>

@if (filterConfig.departmentFilter !== PageFilterType.NOT_ALLOWED) {
	<ic-page-filter-control
		class="department-control"
		inputId="department"
		[placeholder]="'pageFilter.department.search' | translate"
		[selectedOption]="selectedDepartmentOption()"
		[selectedOptionLabel]="selectedDepartmentOptionLabelFn"
		[showLoadingSpinner]="!departmentOptions().length"
		[suggestions]="departmentSuggestions()"
		[(query)]="departmentsQuery"
		(selectedId)="onDepartmentSelected($event)"
	>
		<ng-template #optionTemplate let-item>
			<ic-department-list-item [isOccupationEmpty]="item.isOccupationEmpty" [name]="item.name" />
		</ng-template>
	</ic-page-filter-control>
}

@if (filterConfig.residentFilter !== PageFilterType.NOT_ALLOWED) {
	<ic-page-filter-control
		class="resident-control"
		groupItemsKey="items"
		inputId="resident"
		suggestionsListWidth="large"
		[isReadonly]="isResidentReadonly()"
		[placeholder]="'pageFilter.resident.search' | translate"
		[selectedOption]="selectedResidentOption()"
		[selectedOptionLabel]="selectedResidentOptionLabelFn"
		[showLoadingSpinner]="!residentOptionsGroupedByDepartment().length"
		[suggestions]="residentSuggestions()"
		[(query)]="residentsQuery"
		(selectedId)="onResidentSelected($event)"
	>
		<ng-template #optionTemplate let-item>
			@if (!item.id) {
				{{ item | name: residentOptionNameOrder }}
			} @else {
				<ic-resident-list-item
					[department]="item.department"
					[image]="item.picture"
					[name]="item | name: residentOptionNameOrder"
					[presence]="item.presence?.presence"
					[room]="item.room"
				/>
			}
		</ng-template>

		<ng-template #selectedOptionPrefixTemplate let-item>
			@if (item?.picture) {
				<ic-resident-avatar [imageSource]="item.picture" />
			}
		</ng-template>
	</ic-page-filter-control>
}

@if (selectedResident(); as selectedResident) {
	@let residentPresence = selectedResident.presence?.presence;
	<dl class="active-resident-details">
		<div>
			<dd data-test="resident-presence">
				@if (permissionsService.userHasPermissions(["PORTAL.SHT.MANAGE_SHT"])) {
					<a queryParamsHandling="preserve" [routerLink]="['residents', 'status']">
						<ng-template *ngTemplateOutlet="residentPresenceTmpl" />
					</a>
				} @else {
					<ng-template *ngTemplateOutlet="residentPresenceTmpl" />
				}
				<ng-template #residentPresenceTmpl>
					@if (residentPresence) {
						<ic-resident-presence data-test="resident-presence" [presence]="residentPresence" />
					}
				</ng-template>
			</dd>
		</div>
		@if (hasRestrictiveMeasures()) {
			<icds-tag-actions-button [dataActions]="restrictiveMeasureButtonAction">
				<icds-tag
					[dataDisplay]="'domain-codes.activeEvaluationMeasureType.RESTRICTION.abbreviation' | translate"
					[dataVariant]="hasActiveRestrictiveMeasures() ? 'danger' : 'secondary'"
				/>
			</icds-tag-actions-button>
		}
		@if (residentPresence && !presencesWithoutRoomDisplay.includes(residentPresence)) {
			<div>
				<dt pTooltip="{{ 'labels.profile.room' | translate }}"><i class="fa fa-building"></i></dt>
				<dd data-test="resident-room">{{ selectedResident.room | room }}</dd>
			</div>
		}
		@if (residentPresence === presencePresent) {
			<div>
				<dt pTooltip="{{ 'residents.intake.bedType' | translate }}"><i class="fa fa-bed"></i></dt>
				<dd data-test="resident-bedtype">{{ selectedResidentBedType() | language }}</dd>
			</div>
		}
		@if (medicalInfo()?.katz; as katz) {
			<div>
				<dt>{{ "residents.medical.katz" | translate }}</dt>
				<dd data-test="katz-input">
					{{ katz.score }} <span class="extra">({{ katz.forfait }})</span>
				</dd>
			</div>
		}
		<div>
			<dt
				data-test="resident-gender"
				pTooltip="{{ 'labels.gender.gender' | translate }}: {{
					'labels.gender.' + selectedResident.sex | translate | lowercase
				}}"
			>
				<i
					class="fa"
					[ngClass]="
						selectedResident.sex === 'm' ? 'fa-mars' : selectedResident.sex === 'f' ? 'fa-venus' : 'fa-venus-mars'
					"
				></i>
			</dt>
			<dd
				data-test="resident-birthday"
				pTooltip="{{ 'labels.resident.age' | translate }}: {{
					'labels.time.age' | translate: { amount: selectedResident.birthday | age }
				}}"
			>
				{{ selectedResident.birthday | date }}
			</dd>
		</div>
	</dl>
}
